// 静态目录的路由
export const MENU_STATIC_PAGES = [
    '/game/music',
    '/game/puzzle',
    '/game/dress',
    '/game/block',
    '/game/girls',
    '/game/makeup',
    '/game/all-game',
];

export const STATIC_PAGES_DESCRIPTION_MAP = {
    "/about": "Information about Gameyeap.",
    "/game/all-game": "You can find all free online games you want to play at Gameyeap!",
    "/contact": "Feel free to contact us!",
    "/game/dress": "Dress up games are designed for lovely girls who enjoy time online.",
    "/game/block": "Play block games any time and any where on your browser without installation!",
    "/game/girls": "Special free online games designed are only for lovely girls.",
    "/game/makeup": "Don't hesitate to experience makeup games to be beautiful princess online!",
    "/game/music": "Music games are designed for each one of the kids who love music. You can find Sprunki incredibox, Piano Tiles or any game you love online.",
    "/game/puzzle": "Try to find a wonderful puzzle game online with your smart brain and solve it!"
};

// 静态页面的路由
export const STATIC_PAGES = [
    '/',
    ...MENU_STATIC_PAGES,
    '/about',
    '/contact',
    '/privacy-policy',
];

// TODO：暂时由前端固定菜单栏
export const MENU_DATA = [
    {
        "id": "10011747290941827266209000",
        "path": "music",
        "name": "Music",
        "nameKey": "music",
        "children": [],
        "icon": "/images/icons/menu/music.png"
    },
    {
        "id": "10011747290972213554677000",
        "path": "puzzle",
        "name": "Puzzle",
        "nameKey": "puzzle",
        "children": [],
        "icon": "/images/icons/menu/puzzle.png"
    },
    {
        "id": "10011747290978196124544000",
        "path": "dress",
        "name": "Dress",
        "nameKey": "dress",
        "children": [],
        "icon": "/images/icons/menu/dress.png"
    },
    {
        "id": "10011747290983308859292000",
        "path": "block",
        "name": "Block",
        "nameKey": "block",
        "children": [],
        "icon": "/images/icons/menu/block.png"
    },
    {
        "id": "10011747290988531096626000",
        "path": "girls",
        "name": "Girls",
        "nameKey": "girls",
        "children": [],
        "icon": "/images/icons/menu/girls.png"
    },
    {
        "id": "10011747290994700766389000",
        "path": "makeup",
        "name": "Makeup",
        "nameKey": "makeup",
        "children": [],
        "icon": "/images/icons/menu/makeup.png"
    },
    {
        "id": "all-game",
        "nameKey": "all-game",
        "path": "all-game",
        "name": "All Game",
        "icon": "/images/icons/menu/all-game.png",
        "children": []
    }
];